<template>
  <!-- 其它规则 -->
  <div style="margin-top: 10px;" class="priceTableForm">
    <el-form
      ref="ruleForm"
      :model="formData"
      label-width="0"
      label-position="top"
      class="error-form"
      size="mini"
    >

      <el-table
        :data="formData.arr"
        border
      >
        <!-- 费用类型 仅能选择已配置特殊规则的费用 -->
        <el-table-column min-width="120">
          <template #header>
            <div>
              <span style="color: red;">*</span>
              <span>{{ $t('basicData.ExpenseType') }}</span>
            </div>
          </template>
          <template v-slot="scope">
            <el-form-item
              :prop="'arr.' + scope.$index + '.feeTypeCode'"
              :rules="rules.feeTypeCode"
            >
              <el-select
                v-model="scope.row.feeTypeCode"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                @change="handleChange(scope.row.feeTypeCode, scope.$index)"
              >
                <el-option
                  v-for="item in feeList"
                  :key="item.id"
                  :label="item.displayName + '(' + item.code + ')'"
                  :value="item.code"
                />

              </el-select>
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 计费规则 按特殊规则个性化配置带出 -->
        <el-table-column min-width="300">
          <template #header>
            <div>
              <span style="color: red;">*</span>
              <span>{{ $t('basicData.BillingRules') }}(%)</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="feet-r">
              <div v-if="[2].includes(scope.row.specialRules)" class="feet-r">
                <el-form-item
                  :prop="`arr.${scope.$index}.startNumber`"
                  :rules="getEndRules(scope.row.endNumber, 1)"
                >
                  <el-input-number
                    v-model="scope.row.startNumber" :min="0.1" :max="10000"
                    :precision="1"
                    :controls="false"
                  />
                </el-form-item>
                <span> &lt; {{ $t('basicData.delayTimeCalculation') + ' ≤ ' }}</span>
                <el-form-item
                  :prop="`arr.${scope.$index}.endNumber`"
                  :rules="getEndRules(scope.row.startNumber, 2)"
                >
                  <el-input-number
                    v-model="scope.row.endNumber" :min="0.2" :max="10000"
                    :precision="1"
                    :controls="false"
                  />
                </el-form-item>
                <span>{{ $t('basicData.penaltyAmountFormula') + '*' }}</span>
              </div>
              <div class="flex">
                <el-form-item
                  :prop="'arr.' + scope.$index + '.deliveryFeeRatio'"
                  :rules="rules.deliveryFeeRatio"
                >
                  <el-input-number
                    v-model="scope.row.deliveryFeeRatio" :min="0.01" :max="100"
                    :precision="2"
                    :controls="false"
                  />
                </el-form-item>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column width="100">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="danger"
              @click="handleDel(scope.$index)"
            >{{ $t('basicData.Delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    // 费用类型
    feeList: {
      type: Array,
      default: () => [],
      required: true
    }
  },

  data() {
    const feeTypeCodeCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('GlobalSetObj.pleaseChoose')));
      }

      // 重复校验
      {
        const len = this.formData.arr.length;
        // 如果只有一个，则不需要校验
        if (len === 1) {
          return callback();
        }

        const arr = this.formData.arr.filter(item => item.specialRules !== 2).map(items => {
          return items.feeTypeCode;
        });
        const set = new Set(arr);
        if (set.size !== arr.length) {
          return callback(new Error(this.$t('basicData.重复')));
        }
      }

      // if (!value) {
      //   callback(new Error(this.$i18n.t('basicData.PleaseSelect') + this.$i18n.t('basicData.ExpenseType')));
      // } else {
      //   callback();
      // }
      return callback();
    };
    // 输入校验、正整数
    const integerType = (rule, value, callback) => {
      // const regex = /(^[1-9]\d*$)/;
      const regex = /^(0\.\d|0|[1-9]\d*(\.\d)?)$/;
      const { required } = rule;
      // 数据是否为空
      if (value !== null && value !== '' && value !== undefined) {
        // 格式校验
        if (!regex.test(value)) {
          return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // '格式不正确'
        }
        if (parseFloat(value) <= 0) {
          return callback(new Error(this.$t('basicData.MustBeGreaterThan0'))); // 必须大于0
        }
        // 数据比较
        if (rule.negative === 2) {
          if (parseFloat(value) <= parseFloat(rule.package)) {
            return callback(new Error(this.$t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
          }
          return callback();
        } else {
          if (parseFloat(value) >= parseFloat(rule.package)) {
            return callback(new Error(this.$t('basicData.MustLessThanEndValue'))); // 必须小于结束值
          }
          return callback();
        }
      } else {
        // 必填
        if (required) {
          return callback(this.$t('basicData.CannotBeEmpty')); // '不能为空'
        }
        return callback();
      }
    };
    const getEndRules = (value, type) => {
      console.log('getEndRules', value);
      return {
        required: true,
        suffix: '',
        negative: type,
        package: value,
        validator: integerType,
        trigger: ['blur']
      };
    };

    return {
      getEndRules,
      integerType,
      formData: {
        arr: []
      },

      rules: {
        feeTypeCode: [
          { required: true, validator: feeTypeCodeCheck, trigger: 'change' }
        ],
        deliveryFeeRatio: [
          { required: true, message: this.$t('customerManagements.pleaseInput'), trigger: 'blur' }
        ]
      }
    };
  },

  watch: {
    tableData: {
      handler(val, oldVal) {
        console.log(val, oldVal, '其他规则-cmp');
        if (oldVal === undefined) {
          // 第一次赋值
          this.formData.arr = [];
          return;
        }

        if (val.length === 0 && oldVal.length === 0) {
          return;
        }

        // 新的值与旧的值一样
        if (JSON.stringify(val) === JSON.stringify(this.formData.arr)) {
          return;
        }
        // this.formData.arr = cloneDeep(this.tableData);
        this.formData.arr = val;
      },
      immediate: true
    },

    // 将数据传给父组件
    formData: {
      handler(val, oldVal) {
        if (!oldVal || !val) {
          return;
        }
        this.$emit('change', val.arr);
      },
      deep: true
      // immediate: true
    }
  },
  methods: {
    // 提交校验
    submitForm() {
      return this.$refs['ruleForm'].validate().then(() => {
        return true;
      }).catch(() => {
        return false;
      });
    },

    // 删除
    handleDel(index) {
      console.log(index);
      this.formData.arr.splice(index, 1);
    },

    // 特殊规则费用类型变化
    handleChange(code, index) {
      this.feeList.map(item => {
        if (code === item.code) {
          this.formData.arr[index].specialRules = item.specialRules;
        }
      });
    }
  }
};
</script>
